module.exports = "/assets/data/f16f282b928b3fca75de578a0d308b51-BT51.data.json";